import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { getIsClientLoadedViaSdk } from '@atlassian/commerce-experience-sdk/platform';

/**
 * @typedef {undefined | boolean} InSdkState
 *
 * @description A custom React hook that tracks whether the code is running within the Atlassian Commerce Experience SDK context.
 * @returns {InSdkState} The current state of whether the code is running within the SDK, either `true`, `false`, or `undefined` (should be treated as loading).
 */
export var useSdkState = function useSdkState() {
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    isInSdk = _useState2[0],
    setIsInSdk = _useState2[1];
  useEffect(function () {
    // This variable is used to cancel setting state asynchronously
    // on an unmounted component https://react.dev/reference/react/useEffect#fetching-data-with-effects
    var isMounted = true;
    if (isInSdk === undefined) {
      getIsClientLoadedViaSdk().then(function (value) {
        if (isMounted) {
          setIsInSdk(value);
        }
      });
    }
    return function () {
      isMounted = false;
    };
  }, [isInSdk]);
  return isInSdk;
};